export enum ReportStatus {
  TO_BE_SENT = 'To be sent',
  WAITING_FOR_SIGNATURE = 'Waiting for signature',
  ERROR_REPORTED = 'Error reported',
  FINISHED = 'Finished',
  WAITING_FOR_CORRECTION = 'Waiting for correction',
}
